import { render } from "./TestimonialsSection.vue?vue&type=template&id=1d3a3f34&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=1d3a3f34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d3a3f34"

export default script